import axios from "axios"
import { run_with_shared_contact_confirmation } from "../../utils/shared_contact_confirmation";
import { config } from "../../config"
import { read_brand_list_values } from "../../utils/input/brand_input";

const get_leads = (pageNo, pageSize) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/getLeads`, {
            pageNo: pageNo, 
            pageSize: pageSize
        }, {
            timeout: 20000
        })
        .then(res => {
            resolve(res.data);
        })
        .catch(error => {
            console.error('There was an error fetching leads!', error);           
            return resolve({ leads: [], count: 0, timeout: error?.code === 'ECONNABORTED' })
        });
    })
}

const get_new_lead_leads = (pageNo, pageSize) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/getNewLeadLeads`, {
            pageNo: pageNo,
            pageSize: pageSize
        })
        .then(res => {
            resolve(res.data);
        })
        .catch(error => {
            console.error('There was an error fetching new lead leads!', error);
            return reject(error)
        });
    })
}



const get_lead_history = (leadId) => {
    console.log('HEREE', leadId);
    
    return new Promise((resolve, reject) => {
        axios.get(`${config.NIFFLER_BACKEND_URL}/leads/getLeadHistory?leadId=${leadId}`)
        .then(res => {
            resolve(res?.data?.lead);
        })
        .catch(error => {
            console.error('There was an error fetching lead!', error);           
            return reject(error)
        });
    })
}


const get_lead = (lead) => {
    return new Promise((resolve, reject) => {
        axios.get(`${config.NIFFLER_BACKEND_URL}/leads/getLead`, {
            params: {
                email: lead?.email
            }
        })
        .then(res => {
            resolve(res.data?.lead);
        })
        .catch(error => {
            console.error('There was an error fetching lead!', error);           
            return reject(error)
        });
    })
}

const add_tag = (lead) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/customTag`, {
            data: {
                email: lead?.email,
                firstname: lead?.firstname,
                lastname: lead?.lastname,
                userId: lead?.userId
            }, 
            customTag: {
                name: lead?.customTag, 
                type:'custom'
            }             
    
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}

const reset_tag = (lead) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/resetTag`, {
            data: {
                email: lead?.email,
                firstname: lead?.firstname,
                lastname: lead?.lastname,
                userId: lead?.userId
            }, 
            customTag: {
                name: lead?.customTag, 
                type:'open'
            }             
    
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}

const add_lead = (lead, actions) => {
    return new Promise((resolve, reject) => {
        const brands = read_brand_list_values(lead?.brands, lead?.brand);

        run_with_shared_contact_confirmation(sharedContactsConfirmed => axios.post(`${config.NIFFLER_BACKEND_URL}/leads/addLead`, {
            sharedContactsConfirmed,
            data: {
                email: lead?.email,
                emailList: lead?.emailList,
                emails:lead?.emails,
                firstname: lead?.firstname,
                lastname: lead?.lastname,
                phone: lead?.phone,
                phoneList: lead?.phoneList,
                phones:lead?.phones,
                category: lead?.category,
                subcategory: lead?.subcategory,
                industry: lead?.industry,
                location: lead?.location,
                brand: brands[0] || '',
                brands,
                createdFrom: lead?.createdFrom,
                submittedBy: lead?.submittedBy,
                submittedByName: lead?.submittedByName,
                platformSource: lead?.platformSource,
                prospectStatus: lead?.prospectStatus
            }, 
            sourceTag: {
                name: lead?.sourceName,
                type:'source'
            },
            customTag: {
                name: lead?.customTag, 
                type:'custom'
            },
            autoTag: {
                name: 'Unregistered', 
                type:'auto'
            },
            seller: lead?.assignee,
            actions: actions,
        }))
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}



const add_note = (lead, note) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/addNote`, {
            data: {
                email: lead?.email,
                firstname: lead?.firstname,
                lastname: lead?.lastname,
                userId: lead?.userId
            }, 
            note: lead?.note          
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}


const edit_notes = (lead) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/editNotes`, {
            data: {
                userId: lead?.userId,
                email: lead?.email,
                _id: lead?._id
            }, 
            notes: lead?.notes       
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}

const search_lead = (searchData) => {
    return new Promise((resolve, reject) => {
        axios.get(`${config.NIFFLER_BACKEND_URL}/leads/searchLead`, {
            params: {
                search: searchData
            },
            timeout: 20000
        })
        .then(res => {
            resolve(res.data?.results || []);
        })
        .catch(error => {
            console.error('Error: ', error)
            return resolve([])
        })
    })
}

const search_seller = (sellers, searchData) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/searchSeller`, {
            sellers: sellers,
            search: searchData
        })
        .then(res => {
            resolve(res.data?.results);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}

const add_seller = (seller, status) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/addSeller`, {
            seller: seller.id,
            status: status
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}


const search_tags = (filters, date, setLeads, setLoadingFilters) => {

    console.log('filters', filters);
    return new Promise(async(resolve, reject) => {
        
        let res;
        let leadsFetched = [];
        const wasJustEdited = localStorage.getItem('justEdited') === 'true';

        // This is wrong but it supports up to a million leads
        // If you need to change this line then we have become millionaires :)
    

        for (let i=0; i<100000; i++) {
            res = await axios.post(`${config.NIFFLER_BACKEND_URL}/leads/searchTags`, {
                source: filters?.source,
                auto: filters?.auto,
                custom: filters?.custom,
                startDate: date?.startDate,
                endDate: date?.endDate,
                assign: filters?.assign,
                recent: filters?.recent,
                pageNo: i+1
            }, {
                timeout: 20000
            }).catch(error => {
                console.error('Error: ', error)
                return reject(error)
            })

            // leadsFetched.push(...res?.data?.result?.leads);
            // if (!res?.data?.result?.next) break;


            leadsFetched = [...leadsFetched, ...(res?.data?.result?.leads || [])]
            
            // setLoadingFilters(true)
            if (leadsFetched)  

            console.log('localStorage.getItem', localStorage.getItem('justEdited'));
            
            setLeads(leadsFetched)
            // if (localStorage.getItem('justEdited') === 'true') return resolve(leadsFetched)
            if (!res?.data?.result?.next || localStorage.getItem('justEdited') === 'true') return resolve(leadsFetched);
            
        }
        // setLeads(leadsFetched);
        resolve(leadsFetched);
        
    })
}

const get_sellers = () => {
    return new Promise((resolve, reject) => {
        axios.get(`${config.NIFFLER_BACKEND_URL}/leads/getUsersWithRoles`)
        .then(res => {
            resolve(res.data?.users);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}


const merge_leads = (lead) => {

  
    return new Promise((resolve, reject) => {

        const emailA =lead?.email || lead?.emails?.[0] || lead?.emailList?.[0];
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/mergeLeads`, {
            emailA: emailA,
            emailB: lead?.mergeLead
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}


const toggle_own_ad_account = (leadId, userId, status) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/toggleOwnAdAccount`, {
            leadId,
            userId,
            status
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}

const delete_lead = (lead) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/deleteLead`, {
            lead: lead
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}

const get_users = () => {
    return new Promise((resolve, reject) => {
        axios.get(`${config.NIFFLER_BACKEND_URL}/leads/getUsers`)
        .then(res => {
            resolve(res.data?.users);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}

const assign_seller = (lead) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/assignSeller`, {
            data: {
                email: lead?.email,
                firstname: lead?.firstname,
                lastname: lead?.lastname,
                userId: lead?.userId
            }, 
            seller: lead?.seller         
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}

const edit_lead = (lead) => {
    return new Promise((resolve, reject) => {
        const brands = read_brand_list_values(lead?.brands, lead?.brand);
        const data = {
            _id: lead?._id,
            email: lead?.email,
            emailList: lead?.emailList,
            emails:lead?.emails,
            firstname: lead?.firstname?.trim(),
            lastname: lead?.lastname?.trim(),
            phone: lead?.phone,
            phoneList: lead?.phoneList,
            phones: lead?.phones,
            brand: brands[0] || '',
            brands,
            category: lead?.category?.trim(),
            subcategory: lead?.subcategory?.trim(),
            industry: lead?.industry?.trim(),
            location: lead?.location?.trim()
        };

        if (Object.prototype.hasOwnProperty.call(lead || {}, 'mainPlatform')) {
            data.mainPlatform = lead?.mainPlatform?.trim();
        }

        if (Object.prototype.hasOwnProperty.call(lead || {}, 'message')) {
            data.message = lead?.message?.trim();
        }

        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/editLead`, { data })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}

const update_prospect_lead_status = (leadId, prospectStatus) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/updateProspectLeadStatus`, {
            leadId: leadId,
            prospectStatus: prospectStatus
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}

const assign_legacy_prospect_lead = (leadId, seller, prospectStatus, lead) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/assignSeller`, {
            data: {
                _id: lead?._id || leadId,
                email: lead?.email || lead?.emails?.[0] || lead?.emailList?.[0] || '',
                firstname: lead?.firstname,
                lastname: lead?.lastname,
                userId: lead?.userId,
                prospectStatus: prospectStatus
            },
            seller: seller,
            prospectStatus: prospectStatus
        })
        .then(res => {
            if (res?.data?.code !== 'T2011') {
                return resolve(false);
            }

            resolve({
                ...lead,
                _id: lead?._id || leadId,
                sellerId: seller,
                assignee: seller,
                prospectStatus: prospectStatus
            });
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}

const assign_prospect_lead = (leadId, seller, prospectStatus, lead) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/assignProspectLead`, {
            leadId: leadId,
            seller: seller,
            prospectStatus: prospectStatus
        })
        .then(res => {
            resolve(res.data?.lead);
        })
        .catch(error => {
            if (error?.response?.status === 404) {
                return assign_legacy_prospect_lead(leadId, seller, prospectStatus, lead)
                    .then(resolve)
                    .catch(reject);
            }

            console.error('Error: ', error)
            return reject(error)
        })
    })
}

const create_offer_from_lead = (leadId) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/createOffer`, {
            leadId: leadId
        })
        .then(res => {
            resolve(res.data);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}

const create_lead_calendar = (calendar) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/createLeadCalendar`, {
            leadId: calendar?.leadId,
            schedule: calendar?.schedule,
            seller: calendar?.seller,
            comment: calendar?.comment
        })
        .then(res => {
            resolve(res.data);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}


const create_action = (action) => {
    return new Promise((resolve, reject) => {
    // for (let i=0; i<actions?.lenght; i++) {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/createAction`, {
            data: {
                leadId: action?.leadId,
                seller: action?.seller,
                action: action?.action,
                schedule: action?.schedule,
                comment: action?.comment,
                prospectStatus: action?.prospectStatus,
                leadStatus: action?.leadStatus,
                outcome: action?.outcome,
                offer: action?.offer
            }
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    // }
    })
}

const delete_action = (actionIds, leadId) => {
    console.log('actionIds', actionIds);
    
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/deleteAction`, {
            actionIds: actionIds,
            leadId: leadId
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}

const get_sources = () => {
    return new Promise((resolve, reject) => {
        axios.get(`${config.NIFFLER_BACKEND_URL}/leads/getSources`)
        .then(res => {
            resolve(res.data?.sources);
        })
        .catch(error => {
            console.error('Error: ', error)
            return reject(error)
        })
    })
}


const search_lead_emails = (data) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/searchLeadEmails`, {
           data
        })
        .then(res => {
            resolve(res)
        })
        .catch(err=>{
            resolve(false)
        })
    })
}

const save_registration = (data) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.NIFFLER_BACKEND_URL}/leads/saveRegistrations`, {
           data
        })
        .then(res => {
            resolve(res)
        })
        .catch(err=>{
            resolve(false)
        })
    })
}


export {
    get_leads,
    get_new_lead_leads,
    get_lead,
    add_tag, 
    add_note,
    edit_notes,
    add_lead,
    search_lead,
    search_tags,
    get_sellers,
    assign_seller,
    add_seller,
    get_users,
    delete_lead,
    search_seller,
    edit_lead,
    reset_tag,
    merge_leads,
    get_lead_history,
    create_action,
    delete_action,
    get_sources,
    search_lead_emails,
    save_registration,
    toggle_own_ad_account,
    update_prospect_lead_status,
    assign_prospect_lead,
    create_offer_from_lead,
    create_lead_calendar
};
